import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, BookOpen, CalendarClock, ClipboardList, FileCheck2, GraduationCap } from "lucide-react";
import { api } from "@/lib/api";
import { Loading, PageTitle, Stat, Empty } from "@/components/Common";
import { ESTADOS_PLAN } from "@/components/PlanificacionForm";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export default function CoordResumen() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/coordinacion/resumen").then((r) => setData(r.data)).catch(() => setData({}));
  }, []);

  if (!data) return <Loading />;
  const planes = data.planificaciones || {};

  return (
    <div data-testid="coord-resumen">
      <PageTitle title="Coordinación académica"
                 subtitle="Seguimiento de docentes, planificaciones, horarios y actividades del centro.">
        <Button className="rounded-full" onClick={() => navigate("/coordinacion/planificaciones")}
                data-testid="ir-planificaciones">
          <FileCheck2 className="mr-2 h-4 w-4" /> Revisar planificaciones
        </Button>
      </PageTitle>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="coord-stats">
        <Stat label="Docentes" value={String(data.docentes ?? 0)} icon={GraduationCap} />
        <Stat label="Materias" value={String(data.materias ?? 0)} icon={BookOpen}
              hint={data.materias_sin_docente ? `${data.materias_sin_docente} sin docente` : "Todas asignadas"} />
        <Stat label="Estudiantes activos" value={String(data.estudiantes ?? 0)} icon={Users} />
        <Stat label="Bloques de horario" value={String(data.bloques_horario ?? 0)} icon={CalendarClock} />
      </div>

      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="Por revisar" value={String(planes.enviada ?? 0)} tone={planes.enviada ? "warning" : "default"}
              icon={FileCheck2} />
        <Stat label="Aprobadas" value={String(planes.aprobada ?? 0)} />
        <Stat label="Con observaciones" value={String(planes.correcciones ?? 0)} />
        <Stat label="Tareas publicadas" value={String(data.tareas ?? 0)} icon={ClipboardList} />
      </div>

      <section className="mt-10">
        <h2 className="font-display text-lg font-semibold">Planificaciones esperando revisión</h2>
        {(data.por_revisar || []).length === 0 ? (
          <div className="mt-4">
            <Empty testId="sin-pendientes">No hay planificaciones pendientes de revisión.</Empty>
          </div>
        ) : (
          <div className="mt-4 space-y-3" data-testid="lista-por-revisar">
            {data.por_revisar.map((p) => (
              <button key={p.id} onClick={() => navigate("/coordinacion/planificaciones")}
                      data-testid={`pendiente-${p.id}`}
                      className="lift flex w-full flex-wrap items-center justify-between gap-3 rounded-lg border border-border/60 bg-card p-5 text-left">
                <div>
                  <p className="font-display text-sm font-bold">{p.titulo}</p>
                  <p className="text-xs text-muted-foreground">
                    {p.docente_nombre} · {p.materia_nombre} · {p.grado} · {p.periodo}
                  </p>
                </div>
                <Badge variant={ESTADOS_PLAN[p.estado]?.variant}>{ESTADOS_PLAN[p.estado]?.label}</Badge>
              </button>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
